export default "__VITE_ASSET__BXYtcWyv__"